import React from 'react';

// fulfillment图标组件
const FulfillmentIcon = ({ width = 90, height = 24 }) => (
    <img 
        src="https://oss.essaone.com/fulfillmentEssone2.svg"
        alt="fulfillment" 
        style={{ width, height,}}
    />
);

export default FulfillmentIcon;